<template>
  <div class="page-container dashboard-container">
    <todo-side-bar selected="dashboard" />
    <h1>{{ $t('pages.dashboard') }}</h1>
    <todo-stat />
  </div>
</template>

<script>
  import TodoStat from './components/Stat.vue'

  export default {
    components: {
      'todo-stat': TodoStat
    }
  }
</script>

<style lang="scss">
  .dashboard-container {
    /* */
  }
</style>
